// extracted by mini-css-extract-plugin
export default {"room-field":"RoomField_room-field__ucG3b","rooms":"RoomField_rooms__Qw1ii","label":"RoomField_label__07jiM","description":"RoomField_description__hxcTO"};